module.exports = __webpack_public_path__ + "img/daishenheen.bf69d07e.png";